import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

const NoUnitsFacility = (props: any) => {
  const { onCheckBoxClick } = props;

  return (
    <div
      className="tab-pane active show"
      id="reset-filters"
      role="tabpanel"
      aria-labelledby="reset-filters-tab"
    >
      <div className="container text-lt-md-center">
        <h5 className="sub-heading mt-3">
          <FormattedMessage id="no-units-found-facility" />
        </h5>
        <p className="para">
          <FormattedMessage id="do-reset-filters" />
        </p>
        <div className="no-units-btn">
          <button
            className="btn primary-card-btn"
            type="button"
            onClick={() =>
              onCheckBoxClick({
                target: { value: 'Featured', checked: true },
              })
            }
          >
            <FormattedMessage id="reset-filters" />
          </button>
          <Link href="#self-storage">
            <button className="btn secondary-card-btn" type="button">
              <FormattedMessage id="find-near-by-location" />
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default NoUnitsFacility;
